export const AUTOMATION_IDS = {
  ANCHOR_TAB: 'anchor-tab',
  ADD_ANCHOR_BTN: 'add-anchor-button',
  ADD_SECTION_BTN: 'add-section-button',
  ANCHOR_SELECTION_DROPDOWN: 'anchor-link-anchor-selection-dropdown',
};
